import { Box, Typography } from '@mui/material';
import { pxToRem } from '@geneo2-web/shared-ui';
import { ConceptItem } from '../../ConceptItem';
import { ConceptsData } from '../../PerformanceDrawer/performanceDrawerData';

type ConceptSectionProps = {
  data: ConceptsData;
};

const styles = {
  card: {},

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: pxToRem(14),
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: pxToRem(8),
  },

  icon: {
    fontSize: pxToRem(18),
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 700,
    color: '#1e293b',
    fontSize: pxToRem(14),
  },

  badge: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: pxToRem(12),
    px: pxToRem(10),
    py: pxToRem(3),
    borderRadius: pxToRem(20),
    background: '#eef2ff',
    color: '#667eea',
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(10),
  },
};

export const ConceptSection = ({ data }: ConceptSectionProps) => {
  if (!data) return null;

  const { noOfAttempted, noOfMastered, list } = data;

  return (
    <Box sx={styles.card}>
      {/* HEADER */}
      <Box sx={styles.header}>
        <Box sx={styles.titleRow}>
          <Typography sx={styles.icon}>📚</Typography>
          <Typography sx={styles.title}>Concepts</Typography>
        </Box>

        {!!noOfAttempted && (
          <Typography sx={styles.badge}>
            {noOfMastered} mastered / {noOfAttempted} attempted
          </Typography>
        )}
      </Box>

      {/* LIST (reuse ConceptItem as-is) */}
      <Box sx={styles.list}>
        {list.map((item, idx) => (
          <ConceptItem key={idx} data={item} />
        ))}
      </Box>
    </Box>
  );
};
